import { inject } from "@angular/core";
import { PermissionService } from "app/core/permissions";
import { NavigationService } from "app/core/navigation/navigation.service";
import { NotificationsService } from "app/layout/common/notifications/notifications.service";
import { ShortcutsService } from "app/layout/common/shortcuts/shortcuts.service";
import { forkJoin } from "rxjs";
//import { QuickChatService } from "app/layout/common/quick-chat/quick-chat.service";
//import { MessagesService } from "app/layout/common/messages/messages.service";

export const initialDataResolver = () => {
  const navigationService = inject(NavigationService);
  const notificationsService = inject(NotificationsService);
  const shortcutsService = inject(ShortcutsService);
  const permissionService = inject(PermissionService);
  //const quickChatService = inject(QuickChatService);
  //const messagesService = inject(MessagesService);

  const module = navigationService.currentModule;

  // Fork join multiple API endpoint calls to wait all of them to finish
  return forkJoin([
    navigationService.get(module), // Módulo Básico
    notificationsService.getAll(),
    shortcutsService.getAll(),
    permissionService.load(),
    //quickChatService.getChats(),
    //messagesService.getAll(),
  ]);
};

export const menuDataResolver = () => {
  const navigationService = inject(NavigationService);
  const module = navigationService.currentModule;
  return forkJoin([navigationService.get(module)]);
};
